export default defineNuxtRouteMiddleware((to) => {
	if (to.name === "components") {
		abortNavigation();

		return navigateTo("/components/kinds");
	}
});
